/*
 * @Description:
 * @Author: xiawenlong
 * @Date: 2021-03-22 19:09:00
 * @LastEditors: xiawenlong
 * @LastEditTime: 2022-04-02 14:19:51
 */
import Vue from 'vue'
import {
  Button,
  Tabbar,
  TabbarItem,
  Icon,
  Sidebar,
  SidebarItem,
  Cell,
  CellGroup,
  Swipe,
  SwipeItem,
  Tab,
  Tabs,
  Rate,
  PullRefresh,
  List,
  Tag,
  Collapse,
  CollapseItem,
  Search,
  GoodsAction,
  GoodsActionIcon,
  GoodsActionButton,
  Grid,
  GridItem,
  Progress,
  Sticky,
  NavBar,
  Switch,
  Toast,
  Field,
  Popup,
  Popover,
  Cascader,
  DropdownMenu,
  DropdownItem,
  RadioGroup,
  Radio,
  Picker,
  DatetimePicker,
  Checkbox,
  CheckboxGroup,
  Dialog,
  Form,
  Image as VanImage,
} from 'vant'

const components = {
  Button,
  Tabbar,
  TabbarItem,
  Icon,
  Sidebar,
  SidebarItem,
  Cell,
  CellGroup,
  Swipe,
  SwipeItem,
  Tab,
  Tabs,
  Rate,
  PullRefresh,
  List,
  Tag,
  Collapse,
  CollapseItem,
  Search,
  GoodsAction,
  GoodsActionIcon,
  GoodsActionButton,
  Grid,
  GridItem,
  Progress,
  Sticky,
  NavBar,
  Switch,
  Toast,
  Field,
  Popup,
  Popover,
  Cascader,
  DropdownMenu,
  DropdownItem,
  RadioGroup,
  Radio,
  Picker,
  DatetimePicker,
  Checkbox,
  CheckboxGroup,
  Dialog,
  Form,
  VanImage,
}

Object.values(components).forEach(component => {
  Vue.use(component)
})
